// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"71ddf1d6","455":"33054766","977":"3df19e48"}[chunkId] + ".chunk.js";
};